// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cosmos Unchained API
 * Provides access to cosmos chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Delegation } from './Delegation';
import {
    DelegationFromJSON,
    DelegationFromJSONTyped,
    DelegationToJSON,
} from './Delegation';
import type { Redelegation } from './Redelegation';
import {
    RedelegationFromJSON,
    RedelegationFromJSONTyped,
    RedelegationToJSON,
} from './Redelegation';
import type { Reward } from './Reward';
import {
    RewardFromJSON,
    RewardFromJSONTyped,
    RewardToJSON,
} from './Reward';
import type { Unbonding } from './Unbonding';
import {
    UnbondingFromJSON,
    UnbondingFromJSONTyped,
    UnbondingToJSON,
} from './Unbonding';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value';

/**
 * Contains info about account details for an address or xpub
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    balance: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    pubkey: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    unconfirmedBalance: string;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    accountNumber: number;
    /**
     * 
     * @type {Array<Value>}
     * @memberof Account
     */
    assets: Array<Value>;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    sequence: number;
    /**
     * 
     * @type {Array<Delegation>}
     * @memberof Account
     */
    delegations: Array<Delegation>;
    /**
     * 
     * @type {Array<Redelegation>}
     * @memberof Account
     */
    redelegations: Array<Redelegation>;
    /**
     * 
     * @type {Array<Reward>}
     * @memberof Account
     */
    rewards: Array<Reward>;
    /**
     * 
     * @type {Array<Unbonding>}
     * @memberof Account
     */
    unbondings: Array<Unbonding>;
}

/**
 * Check if a given object implements the Account interface.
 */
export function instanceOfAccount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "balance" in value;
    isInstance = isInstance && "pubkey" in value;
    isInstance = isInstance && "unconfirmedBalance" in value;
    isInstance = isInstance && "accountNumber" in value;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "sequence" in value;
    isInstance = isInstance && "delegations" in value;
    isInstance = isInstance && "redelegations" in value;
    isInstance = isInstance && "rewards" in value;
    isInstance = isInstance && "unbondings" in value;

    return isInstance;
}

export function AccountFromJSON(json: any): Account {
    return AccountFromJSONTyped(json, false);
}

export function AccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Account {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'balance': json['balance'],
        'pubkey': json['pubkey'],
        'unconfirmedBalance': json['unconfirmedBalance'],
        'accountNumber': json['accountNumber'],
        'assets': ((json['assets'] as Array<any>).map(ValueFromJSON)),
        'sequence': json['sequence'],
        'delegations': ((json['delegations'] as Array<any>).map(DelegationFromJSON)),
        'redelegations': ((json['redelegations'] as Array<any>).map(RedelegationFromJSON)),
        'rewards': ((json['rewards'] as Array<any>).map(RewardFromJSON)),
        'unbondings': ((json['unbondings'] as Array<any>).map(UnbondingFromJSON)),
    };
}

export function AccountToJSON(value?: Account | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'balance': value.balance,
        'pubkey': value.pubkey,
        'unconfirmedBalance': value.unconfirmedBalance,
        'accountNumber': value.accountNumber,
        'assets': ((value.assets as Array<any>).map(ValueToJSON)),
        'sequence': value.sequence,
        'delegations': ((value.delegations as Array<any>).map(DelegationToJSON)),
        'redelegations': ((value.redelegations as Array<any>).map(RedelegationToJSON)),
        'rewards': ((value.rewards as Array<any>).map(RewardToJSON)),
        'unbondings': ((value.unbondings as Array<any>).map(UnbondingToJSON)),
    };
}

